import config from 'config';
import { useState, useEffect } from 'react';
import { useApi } from './withApi';

const useBriteVerify = (email, touched, blurred, delay = 400) => {
  const api = useApi();
  const [status, setStatus] = useState(null);
  const bypass = config.briteVerify.bypass;

  useEffect(() => {
    if (!email || !touched || !blurred) {
      setStatus(null);
      return;
    }

    const timer = setTimeout(async () => {
      const looksValid = /.+@.+\..+/.test(email);

      if (!looksValid) {
        setStatus('invalid');
        return;
      }

      if (bypass) {
        setStatus('valid');
        return;
      }

      try {
        const result = await api.validateEmailWithBriteVerify(email);

        const acceptable = ['valid', 'accept_all', 'role_based', 'unknown'];

        const returned = result?.email?.status?.toLowerCase();
        const isDisposable = result?.email?.disposable === true;

        const isValid = acceptable.includes(returned) && !isDisposable;

        setStatus(isValid ? 'valid' : 'invalid');
      } catch {
        setStatus('invalid');
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [email, touched, blurred, api, bypass, delay]);

  return status;
};

export default useBriteVerify;
